import React from "react";
import { Link } from "react-router-dom";

const MobileNavMenu = () => {
  return (
    <nav className="offcanvasNavigation" id="offcanvas-navigation">
      <ul>
        <li>
          <Link to={process.env.PUBLIC_URL + "/"}>Home</Link>
        </li>

        <li>
          <Link to={process.env.PUBLIC_URL + "/service"}>Service</Link>
        </li>

        <li>
          <Link to={process.env.PUBLIC_URL + "/about"}>Methodology</Link>
        </li>
        {/* <li>
          <Link to={process.env.PUBLIC_URL + "/team"}>Our Team</Link>
        </li> */}

        <li>
          <Link to={process.env.PUBLIC_URL + "/contact"}>Contact</Link>
        </li>
      </ul>
    </nav>
  );
};

export default MobileNavMenu;
